import http from '../http'

/* -------------用户相关接口------------------- */
/**
 * 获取token/修改密码并获取token
 * @param {object} user 用户身份, 如: { type: 0, account: '', password: '', newPassword: '', confirmPassword: ''}
 */
export const getToken = user => {
    return http.post('/api/token', user)
}
/**
 * 注销token
 */
export const deleteToken = () => {
    return http.delete('/api/token')
}
/**
 * 更新账户可用状态
 * @param {object} userState 用户状态信息, 如: { enable: false, accounts:['', '']}
 */
export const upState = userState => {
    return http.patch('/api/users', userState)
}
/**
 * 添加用户
 * @param {FormData} user 用户,例:  { id: 0, pid: 0, account: 'string', password: 'string',  name: 'string',  phone: 'string', email: 'string', value: 'string', isEnable: true, image: , eSign:  }
 */
export const addUser = user => {
    return http.post('/api/users', user, {
        headers: { 'Content-Type': 'multipart/form-data' }
    })
}
/**
 * 修改用户
 * @param {FormData} user 用户,例: { id: 0, pid: 0, account: 'string', password: 'string',  name: 'string',  phone: 'string', email: 'string', value: 'string', isEnable: true, image: , eSign:  }
 */
export const editUser = user => {
    return http.put('/api/users', user, {
        headers: { 'Content-Type': 'multipart/form-data' }
    })
}

/**
 * 注销终端
 * @param {array} accounts 账号集合, 例: ['a1','a2']
 */
export const deleteTerminals = accounts => {
    return http.delete('/api/users/terminals', { data: accounts })
}



// WEBPACK FOOTER //
// ./src/api/main/api-user.js